module.exports = __webpack_public_path__ + "static/media/ricardo-perez-off-app-provider-icon.3604d688.svg";